<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">
                    {{dialogTitle}}
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <div id="selected-user" class="inner-panel-dialog" style="height: calc(80vh - 215px)">
                        <table width=100% cellpadding=0 cellspacing=0>
                            <tr class="record-header">
                                <td class="record-header-item" v-t="'message.item_userId'"></td>
                                <td class="record-header-item" v-t="'message.item_participated_group'"></td>
                            </tr>
                            <tr v-if="linkedUserList.length == 0" class="user-talkgroup-record">
                                <td colspan="2" class="record-item" v-t="{ path: 'message.info_no_link_user', args: { tenantName: linkedTenantName } }"></td>
                            </tr>
                            <tr v-else class="user-talkgroup-record" v-for="userTalkGroup in linkedUserList">
                                <td class="record-item">{{ userTalkGroup.userName }}</td>
                                <td class="record-item">{{ userTalkGroup.talkgroupName }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <span v-if="confirmOnly">
                        <el-button class="dialog-ok-button" @click="$emit('ok')">OK</el-button>
                    </span>
                    <span v-else>
                        <el-button class="dialog-ok-button" @click="showConfirm()" v-t="'message.button_disconnect'"></el-button>
                    </span>
                </div>
            </div>
            <deleteusertalkgroup v-if="showDeleteUserTalkgroup" :confirmInfo="confirmInfo" @delete="removeAndDisconnect()" @cancel="showDeleteUserTalkgroup=false"></deleteusertalkgroup>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import DeleteObject from "../../../DeleteObject.vue";

export default {
    data() {
        return {
            showDeleteUserTalkgroup: false,
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
            dialogTitle: null,
            linkedTenantName: null,
            linkedUserList: [],
            linkedTalkGroupList: [],
        };
    },
    methods: {
        getInfo() {
            let self = this;
            let requestType;
            if (this.type == "import") {
                requestType = constants.OBJECT_USER;
            } else {
                requestType = constants.OBJECT_TALKGROUP;
            }
            // get imported user info.
            server.post('/gettenantconnectinfo', { type: requestType , tenantId: this.tenantId })
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.linkedUserList = res.data.userTalkgroup;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                            return;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                });

        },
        getLinkedTenantName(tenantList, tenantId) {
            for (let linkedTenant of tenantList) {
                if (linkedTenant.tenantId == tenantId) {
                    return linkedTenant.tenantName;
                }
            }
        },
        removeAndDisconnect() {
            this.showDeleteUserTalkgroup = false;
            this.$emit('save' , this.linkedUserList);
        },
        showConfirm() {
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_confirm_linked_resource");
            this.confirmInfo.objectName = commonUtil.getMessageText(this.$i18n,"title_link_user").replace('{tenantName}',this.linkedTenantName);
            this.showDeleteUserTalkgroup = true;
        }
    },
    components: {
        deleteusertalkgroup: DeleteObject,
    },
    created: function() {
        if (this.confirmOnly) {
            if (this.type == "import") {
                this.linkedTenantName = this.getLinkedTenantName(this.appData.importedTenantList, this.tenantId);
                this.dialogTitle = commonUtil.getMessageText(this.$i18n,"title_link_import_user").replace('{tenantName}',this.linkedTenantName);
            } else {
                this.linkedTenantName = this.getLinkedTenantName(this.appData.exportedTenantList, this.tenantId);
                this.dialogTitle = commonUtil.getMessageText(this.$i18n,"title_link_export_user").replace('{tenantName}',this.linkedTenantName);
            }
        } else {
            this.linkedTenantName = this.getLinkedTenantName(this.appData.importedTenantList, this.tenantId);
            this.dialogTitle = commonUtil.getMessageText(this.$i18n,"title_link_remove_and_disconnect").replace('{tenantName}',this.linkedTenantName);
        }
        return this.getInfo();
    },
    props: ['appData' , 'tenantId' , 'confirmOnly' , 'type' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inner-panel-description {
    padding: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #fff;
    border-right: 1px #eee solid;
}
.record-header {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.record-header-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.user-talkgroup-record {
    border-bottom:1px #eee solid;
}
.record-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
}

</style>

